module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-header', {
    attrs: {
      "title": _vm.$route.params.title,
      "backFn": "true"
    },
    on: {
      "back": _vm.back
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "take-wine-box"
  }, [_vm._l((_vm.res), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "list ",
      attrs: {
        "tag": "div",
        "to": {
          name: 'takeWineDetail',
          params: {
            id: item.rob_id
          }
        }
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      staticClass: "img-block",
      attrs: {
        "src": item.image_default_id,
        "default-src": "static/placeholder.png",
        "container": "#vux_view_box_body"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "contont text-l flex"
    }, [_c('div', {
      staticClass: "tag ellipsis-1 "
    }, [(item.status == 'ENDING') ? _c('span', {
      staticClass: "end vux-1px"
    }, [_vm._v("已揭晓")]) : _vm._e(), _vm._v(" "), (item.status == 'WORKING') ? _c('span', {
      staticClass: "start vux-1px"
    }, [_vm._v("进行中")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "xq"
    }, [_vm._v(_vm._s(item.sub_title))])]), _vm._v(" "), _c('div', {
      staticClass: "title flex-1 ellipsis-2"
    }, [_vm._v("\n                    " + _vm._s(item.title) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "flex-1"
    }, [_c('div', {
      staticClass: "des flex"
    }, [_c('span', [_vm._v("开奖进度" + _vm._s(_vm.progress(item)))]), _c('span', [_vm._v("总需" + _vm._s(item.buy_number) + "份")])]), _vm._v(" "), _c('div', {
      staticClass: "progress"
    }, [_c('i', {
      style: ({
        width: _vm.progress(item)
      })
    })])]), _vm._v(" "), _c('div', {
      staticClass: "btn"
    }, [_vm._v(_vm._s(item.status == 'ENDING' ? '去看看' : '去夺酒'))])])])])
  }), _vm._v(" "), (_vm.res.length == 0) ? _c('not-date', {
    attrs: {
      "text": "暂无夺酒活动",
      "imgPic": "nodate"
    }
  }) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b7f4d62"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeTakeWine/HomeTakeWine.vue
// module id = 598
// module chunks = 0